import { DestroyRef, Injectable, inject } from '@angular/core';
import { catchError, first, forkJoin, of } from 'rxjs';
import { Logger } from '../../interfaces/Logger';
import { NetworkConnectionService } from '../../services/network-connection/network-connection.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { SERVICE_STATE_SERVICE } from '@features/service/domain/tokens/service-state.token';
import { Worker } from '@features/service/domain/models/worker.model';



@Injectable({
  providedIn: 'root',
})
export class WaiterStatusService {
  private readonly networkConnectionService = inject(NetworkConnectionService);
  private readonly logger = inject(Logger);
  private readonly destroyRef = inject(DestroyRef);

  private readonly serviceStateService = inject(SERVICE_STATE_SERVICE);

  constructor() {
    this.listenNetworkConnection();
  }

  private checkWaiterStatus(): void {
    forkJoin([
      of(this.serviceStateService.getAllWorkers()),
      of(this.serviceStateService.getCurrentWorker()),
    ])
      .pipe(
        first(),
        catchError((error) => {
          this.logger.error(
            new Error('Error fetching waiters or current waiter:'),
            error
          );

          return of([null, null]);
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(
        ([workers, currentWorker]:
          | [Worker[] | null, Worker | null]
          | null[]) => {
          if (!currentWorker || !workers) {
            return;
          }

          const hasCurrentWorker = workers.some(
            (worker: Worker) => worker.id === currentWorker.id
          );

          if (!hasCurrentWorker) {
            this.serviceStateService.removeCurrentWorker();
          }
        }
      );
  }

  private listenNetworkConnection(): void {
    this.networkConnectionService.onNetworkConnectionChanged$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (isInternetConnected: boolean) => {
          if (isInternetConnected) {
            this.checkWaiterStatus();
          }
        }
      );
  }
}
